import { z } from 'zod';
import { addCtaPairIssues, addPublishWindowIssues, adminMetadataSchema, contentStatusChangeSchema, imageReferenceSchema, nonEmptyUpdate, publishWindowShape, safeLinkSchema, slugSchema, } from './common.js';
const heroSlideEditableShape = {
    slug: slugSchema,
    titulo: z.string().min(1),
    descripcion: z.string().min(1).nullable(),
    imagenUrl: imageReferenceSchema,
    imagenAlt: z.string().min(1).nullable(),
    ctaLabel: z.string().min(1).nullable(),
    ctaUrl: safeLinkSchema.nullable(),
    orden: z.number().int(),
};
const heroSlideWriteShape = { ...heroSlideEditableShape, ...publishWindowShape };
export const createHeroSlideSchema = z
    .object({
    ...heroSlideEditableShape,
    orden: heroSlideEditableShape.orden.optional(),
    status: publishWindowShape.status.optional(),
    publishAt: publishWindowShape.publishAt.optional(),
    unpublishAt: publishWindowShape.unpublishAt.optional(),
})
    .superRefine((value, context) => {
    addPublishWindowIssues(value, context);
    addCtaPairIssues(value, context);
});
export const updateHeroSlideSchema = nonEmptyUpdate(z.object(heroSlideWriteShape));
export const heroSlideStatusChangeSchema = contentStatusChangeSchema;
export const publicHeroSlideSchema = z.object({
    titulo: heroSlideEditableShape.titulo,
    descripcion: heroSlideEditableShape.descripcion,
    imagenUrl: heroSlideEditableShape.imagenUrl,
    imagenAlt: heroSlideEditableShape.imagenAlt,
    ctaLabel: heroSlideEditableShape.ctaLabel,
    ctaUrl: heroSlideEditableShape.ctaUrl,
});
export const publicHeroSlideListSchema = z.array(publicHeroSlideSchema);
export const publicHeroSlideFields = Object.freeze(Object.keys(publicHeroSlideSchema.shape));
export const adminHeroSlideSchema = z
    .object({ id: z.number().int().positive(), ...heroSlideWriteShape })
    .extend(adminMetadataSchema.shape);
export const adminHeroSlideListSchema = z.array(adminHeroSlideSchema);
export const heroSlidePreviewSchema = z.object({
    content: publicHeroSlideSchema,
    effectiveVisibility: adminMetadataSchema.shape.effectiveVisibility,
    publishAt: publishWindowShape.publishAt,
    unpublishAt: publishWindowShape.unpublishAt,
});
//# sourceMappingURL=hero-slides.js.map